import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchData } from "../../../api/cancuiApi";


function useGetCancuiDetails(id) {

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        setIsLoading(true);

        fetchData("CC_Nominals", { subject_filter: `sensor = '${id}'` })
            .then((res) => {
                if (res.objs && res.objs.length > 0) {
                    setData(res.objs[0]);
                } else {
                    setData();
                }
            }).catch((error) => {
                console.error("Error fetching CAN-CUI details:", error);
                toast.error("Error fetching CAN-CUI details. Please try again later.");
                setIsError(true);
            }
            ).finally(() => {
                setIsLoading(false);
            }
            );


    }, [id]);

    return {
        data,
        isLoading,
        isError,
    };
}
export default useGetCancuiDetails;